import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';

const ComplementoDonatarias = (props) => {

  let initialState = props.data || {};

  const [data, setData] = useState(initialState);

  const [validation, setValidation] = useState({
    validator: new Validator({}, rules),
    isValid: false
  });

  const { isValid } = validation;

  const handleOnChange = (event) => {
    const newState = {
      ...data,
      ...event,
    };

    setData(newState);
  }

  const validate = (data) => {
    const validator = new Validator(data, rules);

    setValidation({
      validator: validator,
      isValid: validator.passes()
    });
  }

  useEffect(() => {
    validate(data);
  }, [data]);

  const handleOnAdd = () => {
    const Donatarias = {
      ...data,
    };

    props.onChange({ Donatarias });

    clearState();
  }

  const handleOnCancel = () => {
    props.onCancel('Donatarias');
  }

  const clearState = () => {
    setData({});
  }

  return (
    <>
      <div className="pb-4 text-right">
        <strong className="text-black text-upper">Complemento Donatarias</strong>
      </div>

      <div className="pb-4">
        <div className="section pt-2">

          <Form autoComplete="off">
            <Row>
              <Col sm md={ 3 }>
                <FormControl type="text"
                  label="Número Autorización"
                  name="noAutorizacion"
                  placeholder=""
                  help=""
                  rules={ rules.noAutorizacion }
                  value={ data.noAutorizacion }
                  onChange={ handleOnChange }
                />
              </Col>

              <Col sm md={ 3 }>
                <FormControl type="date-picker"
                  id="fechaAutorizacion"
                  label="Fecha Autorización"
                  name="fechaAutorizacion"
                  rules={ rules.fechaAutorizacion }
                  value={ data.fechaAutorizacion }
                  onChange={ handleOnChange }
                />
              </Col>

            </Row>

            <Row>
              <Col col={ 12 }>
                <FormControl as="textarea"
                  label="Leyenda"
                  name="leyenda"
                  rows="3"
                  placeholder=""
                  help=""
                  rules={ rules.leyenda }
                  value={ data.leyenda }
                  onChange={ handleOnChange }
                />
              </Col>
            </Row>

            <Row className="pb-3 text-right">
              <Col>
                <Button variant="secondary"
                  className="mr-3"
                  onClick={ handleOnCancel }
                >
                  Cancelar
                </Button>

                <Button variant="primary"
                  disabled={ !isValid }
                  onClick={ handleOnAdd }
                >
                  Agregar complemento
                </Button>
              </Col>
            </Row>

          </Form>
        </div>
      </div>
    </>
  );
}

const rules  = {
  noAutorizacion: ['required', 'string'],
  fechaAutorizacion: ['required'],
  leyenda: ['required', 'string'],
}

export default ComplementoDonatarias;